import type * as api from '@gitbook/api-client';
import { Icon as FAIcon, type IconName as FAIconName } from '@gitbook/icons';
import { Icon } from '@gitbook/spine-icons';

export function SiteSectionGroupIcon(props: {
    siteSectionGroup: api.SiteSectionGroup;
    size?: number;
    className?: string;
}) {
    const { siteSectionGroup, ...iconProps } = props;
    return siteSectionGroup.icon ? (
        <FAIcon icon={siteSectionGroup.icon as FAIconName} {...iconProps} />
    ) : (
        <Icon.SiteGroup {...iconProps} />
    );
}
